<template>
  <ValidationObserver slim v-slot="{ handleSubmit, invalid }" ref="observer">
    <form class="space-y-16" @submit.prevent="handleSubmit(submitAccountData)">
      <div class="space-y-8">
        <div class="space-y-1">
          <h3 class="text-indigo-500">New Account</h3>
        </div>

        <ValidationProvider
          name="name"
          vid="name"
          rules="required"
          v-slot="{ errors, failed }"
          slim
        >
          <BaseFormGroup class="w-full">
            <BaseFormLabel for="company_name"> Company Name * </BaseFormLabel>
            <BaseFormInput
              id="company_name"
              v-model="accountData.name"
              :disabled="submitting"
              :invalid="failed"
              placeholder="enter company name..."
              v-select
            />
            <BaseFormInlineMessage v-if="failed" danger>
              {{ errors[0] }}
            </BaseFormInlineMessage>
          </BaseFormGroup>
        </ValidationProvider>

        <ValidationProvider
          name="type"
          vid="type"
          rules="required|oneOf:client,organization,provider"
          v-slot="{ errors, failed }"
          slim
        >
          <BaseFormGroup class="w-full">
            <BaseFormLabel for="account_type"> Type * </BaseFormLabel>
            <BaseFormSelect
              id="account_type"
              v-model="accountData.type"
              :options="accountTypeOptions"
              :disabled="submitting"
              :invalid="failed"
            />
            <BaseFormInlineMessage v-if="failed" danger>
              {{ errors[0] }}
            </BaseFormInlineMessage>
          </BaseFormGroup>
        </ValidationProvider>
      </div>

      <div class="space-y-8">
        <div class="space-y-1">
          <h6 class="text-gray-900 font-normal">CONTACT INFO</h6>
        </div>

        <ValidationProvider
          name="email"
          vid="email"
          rules="required|email"
          v-slot="{ errors, failed }"
          slim
        >
          <BaseFormGroup class="w-full">
            <BaseFormLabel for="company_email"> Email * </BaseFormLabel>
            <BaseFormInput
              id="company_email"
              type="email"
              v-model="accountData.email"
              :disabled="submitting"
              :invalid="failed"
              placeholder="enter company email..."
            />
            <BaseFormInlineMessage v-if="failed" danger>
              {{ errors[0] }}
            </BaseFormInlineMessage>
          </BaseFormGroup>
        </ValidationProvider>

        <div class="flex -mx-4">
          <div class="w-3/5 px-4">
            <ValidationProvider
              name="phone"
              vid="phone"
              rules="required|digits:10"
              v-slot="{ errors, failed }"
              slim
            >
              <BaseFormGroup class="w-full">
                <BaseFormLabel for="company_phone"> Phone * </BaseFormLabel>
                <BaseFormInput
                  id="company_phone"
                  v-model="accountData.phone"
                  :disabled="submitting"
                  :invalid="failed"
                  placeholder="enter company phone..."
                />
                <BaseFormInlineMessage v-if="failed" danger>
                  {{ errors[0] }}
                </BaseFormInlineMessage>
              </BaseFormGroup>
            </ValidationProvider>
          </div>
        </div>
      </div>
      <div class="space-x-2 text-right">
        <BaseButton type="button" ghost :disabled="submitting" @click="backToAccounts">
          Cancel
        </BaseButton>
        <BaseButton type="submit" primary :disabled="invalid || submitting"> Create </BaseButton>
      </div>
    </form>
  </ValidationObserver>
</template>

<script>
export default {
  name: 'FormCreate',
  props: {
    submitting: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    accountData: {
      name: '',
      type: null,
      email: '',
      phone: '',
    },
    accountTypeOptions: [
      { value: 'client', label: 'Client' },
      { value: 'organization', label: 'Organization' },
      { value: 'provider', label: 'Provider' },
    ],
  }),
  methods: {
    submitAccountData() {
      this.$emit('submit', { ...this.accountData });
    },
    backToAccounts() {
      this.$router.replace({ name: 'accounts' });
    },
  },
};
</script>
